import React, { useEffect, useState } from 'react';
import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact';
import { useDispatch, useSelector } from 'react-redux';
import addNotification from 'helpers/notify';
import { useHttp } from 'hooks/useHttp';
import Loading from 'components/ui-components/loading';
import Select from "react-select";
import './CreateIdeaModal.scss';
import { addNewIdea, updateIdea } from 'api/ideas/addUpdateIdea';
import { addIdea, onSelectedIdea, onUpdateIdea } from 'actions/idea';

const CreateIdeaModal = ({ isOpen, toggleModal, id }) => {
    const dispatch = useDispatch();
    const brandsRedux = useSelector((s) => s.user.brands);
    const selectedIdea = useSelector(s => s.ideas.selectedIdea);
    const brandOptions = brandsRedux?.map((i) => ({
        label: i.name,
        value: i._id,
    }));

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [prompt, setPrompt] = useState('');
    const [brandId, setBrandId] = useState('');
    const [date, setDate] = useState("");

    useEffect(() => {
        if (selectedIdea) {
            setTitle(selectedIdea.title);
            setDescription(selectedIdea.description);
            setPrompt(selectedIdea.prompt);
            setBrandId(selectedIdea.brandId?._id);
            setDate(new Date(selectedIdea?.date ?? null).toISOString().split('T')[0]);
        }
    }, [selectedIdea]);

    const handleClose = () => {
        setTitle('');
        setDescription('');
        setPrompt('');
        setBrandId('');
        setDate('');
        dispatch(onSelectedIdea(null));
        toggleModal();
    };

    const { loading: createIdeaLoader, request: createIdeaAPI } = useHttp({
        requestCallback: (data) => addNewIdea(data),
        onLoad: (res) => {
            dispatch(addIdea(res));
            addNotification("Idea was successfully created!", "success");
            handleClose();
        },
        onError: (res) => {
            addNotification(
                "Something went wrong while creating your idea, please contact support.",
                "danger"
            );
        },
    });

    const { loading: updateIdeaLoader, request: updateIdeaAPI } = useHttp({
        requestCallback: (data) => updateIdea(data),
        onLoad: (res) => {
            dispatch(onUpdateIdea(res));
            addNotification("Idea was successfully updated!", "success");
            handleClose();
        },
        onError: (res) => {
            addNotification(
                "Something went wrong while updating your idea, please contact support.",
                "danger"
            );
        },
    });

    const handleSubmit = () => {
        const data = { title, prompt, description, brandId, date: new Date(date) };
        if (!selectedIdea) {
            createIdeaAPI(data);
        } else {
            if (selectedIdea.status !== 'pending') {
                addNotification(
                    "You cannot update this Idea! You can only view.",
                    "danger"
                );
                return;
            }
            data._id = selectedIdea._id;
            updateIdeaAPI(data);
        }
    }

    return (
        <MDBModal
            isOpen={isOpen}
            toggle={handleClose}
            size="lg"
            centered
            className="create-post-modal"
        >
            <MDBModalHeader toggle={handleClose}>
                <span className="modal-title">{selectedIdea?._id ? "Update Idea" : "Create Idea"}</span>
            </MDBModalHeader>

            <MDBModalBody>
                <div className="form-layout">
                    <div className="form-section">
                        <div className="section-title">Title</div>
                        <div className="date-time-section">
                            <input
                                type="text"
                                value={title}
                                placeholder='Title for the Idea...'
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="section-title">Prompt</div>
                        <div className="date-time-section">
                            <input
                                type="text"
                                value={prompt}
                                placeholder='Prompt for AI Model...'
                                onChange={(e) => setPrompt(e.target.value)}
                            />
                        </div>
                        <div className="section-title">Date</div>
                        <div className="date-time-section">
                            <input
                                type="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().split('T')[0]}
                            />
                        </div>

                        <div className="section-title">Brand</div>
                        <div className='date-time-section'>
                            <Select
                                ckassName="brands"
                                options={brandOptions}
                                placeholder='Select a Brand'
                                value={brandOptions?.find(x => x.value === brandId)}
                                onChange={(option) => setBrandId(option.value)}
                            />
                        </div>
                        <div className="section-title">Idea</div>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Type your idea here..."
                        />
                    </div>
                </div>
            </MDBModalBody>

            <div className="modal-footer">
                <button
                    className="btn-cancel"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    className="btn-schedule"
                    onClick={() => handleSubmit()}
                    disabled={(updateIdeaLoader || createIdeaLoader) || !brandId || !title || !prompt || !description}
                >
                    {updateIdeaLoader || createIdeaLoader ? <Loading /> : 'Save'}
                </button>
            </div>
        </MDBModal>
    )
}

export default CreateIdeaModal;